<template
    ><div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Client name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.name ? activeClient.name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Chain name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.chain_name ? activeClient.chain_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Shop name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.shop_name ? activeClient.shop_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ getClientCountry()
                }}<country-flag
                    v-if="activeClient && activeClient.country_code"
                    :country="activeClient.country_code"
                    class="ml-1"
                    size="small"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.address ? activeClient.address : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Coordinates (lat/lon)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.latitude ? activeClient.latitude : "-" }};{{
                    activeClient.longitude ? activeClient.longitude : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.comment ? activeClient.comment : "-" }}
            </v-col>
        </v-row>
    </div></template
>

<script>
import { mapState } from "vuex";
import CountryFlag from "vue-country-flag";

export default {
    name: "client-info-tab",
    components: {
        CountryFlag
    },
    computed: {
        ...mapState("ClientStore", ["activeClient"])
    },
    methods: {
        getClientCountry() {
            if (this.activeClient.country_estonian) {
                return this.activeClient.country_estonian;
            }
            if (this.activeClient.country_english) {
                return this.activeClient.country_english;
            }
            return "-";
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
